module.exports = __webpack_public_path__ + "static/media/iw-logo-2-white.c2b90c14.svg";